import React, { useEffect, useState } from "react";
import { getAgreementServicesforAgreement } from '../../api/Agreement';
import { useAuth } from "../../providers/AuthContext";
import Switch from "../Switch";
import InputField from "../InputField";

const AgreementServices = ({ agreementPublicId, setServices = () => {}, services, setHasChanges = () => {}}) => {
    const { getAccessToken } = useAuth();
    const [agreementServices, setAgreementServices] = useState([]);

    useEffect(() => {
        handleGetAllAgreementServices();
    }, [agreementPublicId]);

    useEffect(() => {
        setServices(agreementServices);
    }, [agreementServices]);

    const handleGetAllAgreementServices = async () => {
        try {
            const accessToken = await getAccessToken();
            const data = await getAgreementServicesforAgreement(agreementPublicId, accessToken);
            setAgreementServices(data);
        } catch (error) {
            console.error("Failed to fetch agreement services:", error);
        }
    };

    // Group services by category
    const grouped = agreementServices.reduce((acc, service) => {
        const cat = service.category || "Uncategorized";
        if (!acc[cat]) {
            acc[cat] = {
                name: cat,
                sortOrder: service.categorySortOrder,
                items: []
            };
        }
        acc[cat].items.push(service);
        return acc;
    }, {});

    const categories = Object.values(grouped).sort((a, b) => a.sortOrder - b.sortOrder);

    return (
        <>
            {categories.map((cat) => (
                <div key={cat.name} className="mb-4">
                    <div className="bg-gray-100 px-3 py-2 rounded-t-md border-b">
                        <h3 className="font-semibold text-sm">{cat.name}</h3>
                    </div>
                    <table className="table-default w-full">
                        <thead>
                            <tr>
                                <th className="w-8"></th>
                                <th className="text-left">Name</th>
                                <th className="text-left">Comment</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cat.items.map((service) => {
                                const globalIndex = agreementServices.findIndex(
                                    s => s.agreementServicePublicId === service.agreementServicePublicId
                                );
                                return (
                                    <tr key={service.agreementServicePublicId}>
                                        <td>
                                            <Switch
                                                type="checkbox"
                                                checked={service.isActiveForAgreement}
                                                onChange={(e) => {
                                                    setAgreementServices((s) =>
                                                        s.map((srv, i) =>
                                                            i === globalIndex
                                                                ? { ...srv, isActiveForAgreement: e, hasUpdatedIsActiveForAgreement: true }
                                                                : srv
                                                        )
                                                    );
                                                    setHasChanges(true);
                                                }}
                                            />
                                        </td>
                                        <td>{service.name}</td>
                                        <td>
                                            <InputField
                                                placeholder="Comment"
                                                value={service.comment}
                                                onChange={(e) => {
                                                    setAgreementServices((s) =>
                                                        s.map((srv, i) =>
                                                            i === globalIndex
                                                                ? { ...srv, comment: e.target?.value, hasUpdatedComment: true }
                                                                : srv
                                                        )
                                                    );
                                                    setHasChanges(true);
                                                }}
                                                className="w-full"
                                                disabled={false}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            ))}
        </>
    );
};

export default AgreementServices;
